import { type Container, ContainerType, type Section, SectionType, type Slice } from './types'

function getSectionType(slice: Slice): SectionType {
  switch (slice.layout) {
    case 'boxed_33':
    case 'boxed_66':
    case 'free_33':
    case 'free_66':
      return SectionType.SIDEBAR
    case 'boxed_100':
      return SectionType.VERTICAL_BOX
    case 'free_100':
      return SectionType.VERTICAL_FREE
    case 'free_fluid':
      return SectionType.FLUID
  }
}

function getContainerType(slice: Slice): ContainerType {
  return slice.layout.includes('boxed') ? ContainerType.BOX : ContainerType.FREE
}

export function buildLayout(slices: Slice[]): Section[] {
  const sections: Section[] = []

  let currentSection: Section | undefined
  let currentContainer: Container | undefined
  let currentAside: Container | undefined

  function flushCurrentSection() {
    if (currentSection?.items.length) {
      sections.push(currentSection)
    }
    currentSection = undefined
  }

  function flushCurrentContainer() {
    if (currentSection && currentContainer?.slices.length) {
      currentSection.items.push(currentContainer)
    }
    currentContainer = undefined
  }

  function addToSection(slice: Slice) {
    const sectionType = getSectionType(slice)

    if (sectionType !== currentSection?.type) {
      currentAside = undefined
      flushCurrentContainer()
      flushCurrentSection()
      currentSection = { type: sectionType, items: [] }
    }

    if (slice.layout.includes('33')) {
      flushCurrentContainer()
      addToAside(slice)
    } else if (slice.layout.includes('free')) {
      flushCurrentContainer()
      addToContainer(slice)
    } else {
      addToContainer(slice)
    }
  }

  function addToAside(slice: Slice) {
    if (!currentAside) {
      currentAside = { type: ContainerType.ASIDE, slices: [] }
      currentSection?.items.push(currentAside)
    }
    currentAside.slices.push(slice)
  }

  function addToContainer(slice: Slice) {
    const containerType = getContainerType(slice)
    if (containerType !== currentContainer?.type) {
      flushCurrentContainer()
      currentContainer = { type: containerType, slices: [] }
    }
    if (slice.content) {
      currentContainer.slices.push(slice)
    }
  }

  slices.forEach((slice) => {
    addToSection(slice)
  })
  flushCurrentContainer()
  flushCurrentSection()

  return sections
}
